import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { TextInput } from 'grommet/components/TextInput';
import { ERRORMESSAGE } from '../Constants.js';
import { number, phoneNumber, emailRegex } from '../Utils/Utility.js';
import { StatusInfo } from 'grommet-icons';

class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo ? <Text className='error' style={{width:'250px'}} >{this.props.testo}</Text> : <Text className='errorhide'></Text>}
            </Box>
        );
    }
}



class FormSociety extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.state = {

        }

    }

    render() {

        return (
            <Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CODICE SOCIETÀ</Text>
                        <TextInput id='codsoc' size='medium' maxLength={10} className={`inputForm ${this.props.msgcodsoc ? 'errorBoxInput' : '' }`} value={this.props.codsocieta} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcodsoc} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>PARTITA IVA</Text>
                        <TextInput id='piva' size='medium' maxLength={11} className={`inputForm ${this.props.msgpiva ? 'errorBoxInput' : '' }`} value={this.props.piva} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgpiva} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CAP SOCIETÀ</Text>
                        <TextInput id='capsoc' size='medium' maxLength={5} className={`inputForm ${this.props.msgcapsoc ? 'errorBoxInput' : '' }`} value={this.props.capsocieta} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcapsoc} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>NOME LEGALE RAPPRESENTANTE</Text>
                        <TextInput id='nomelegale' maxLength={50} size='medium' className={`inputForm ${this.props.msgnomleg ? 'errorBoxInput' : '' }`} value={this.props.nome} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgnomleg} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>COGNOME LEGALE RAPPRESENTANTE</Text>
                        <TextInput id='cognomelegale' maxLength={50} size='medium' className={`inputForm ${this.props.msgcogleg ? 'errorBoxInput' : '' }`} value={this.props.cognome} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcogleg} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CODICE FISCALE LEGALE RAPPRESENTANTE</Text>
                        <TextInput id='codfislegale' size='medium' maxLength={16}className={`inputForm ${this.props.msgcodfis ? 'errorBoxInput' : '' }`} value={this.props.codicefiscale} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcodfis} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>EMAIL</Text>
                        <TextInput id='email' size='medium' minLength={6} maxLength={50} className={`inputForm ${this.props.msgemail ? 'errorBoxInput' : '' }`} value={this.props.email} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgemail} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>  
                        <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                        <div style={{ display:'inline-flex', width: '300px' }}>
                        <TextInput id='numtel' size='medium' maxLength={15} className={`inputForm ${this.props.msgnumtel ? 'errorBoxInput' : '' }`} value={this.props.numtel} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                            <div class="tooltipPwd"><StatusInfo className="iconTooltip" aria-label="Informazioni sul numero di telefono"/>
                                <span class="tooltiptext">
                                Indicare sempre il prefisso internazionale. Es: +39 per l'Italia
                                </span>
                            </div>
                        </div>
                        <Error testo={this.props.msgnumtel} />
                    </Box>
                </Box>
            </Box>
        );
    }
}


class FormShop extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {

        return (
            <Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CODICE SOCIETÀ</Text>
                        <TextInput id='codsoc' size='medium' className={`inputForm ${this.props.msgcodsoc ? 'errorBoxInput' : '' }`} maxLength={10} codsocieta={this.props.codsocieta} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcodsoc} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CODICE PUNTO VENDITA</Text>
                        <TextInput id='codpv' size='medium' className={`inputForm ${this.props.msgcodpv ? 'errorBoxInput' : '' }`} maxLength={10} codicepv={this.props.codicepv} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcodpv} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>PARTITA IVA</Text>
                        <TextInput id='piva' size='medium' maxLength={11} className={`inputForm ${this.props.msgpiva ? 'errorBoxInput' : '' }`} piva={this.props.piva} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgpiva} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>CAP PUNTO VENDITA</Text>
                        <TextInput id='capsoc' size='medium' maxLength={5} className={`inputForm ${this.props.msgcapsoc ? 'errorBoxInput' : '' }`} capsocieta={this.props.capsocieta} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgcapsoc} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentform'>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>EMAIL</Text>
                        <TextInput id='email' size='medium' maxLength={50} className={`inputForm ${this.props.msgemail ? 'errorBoxInput' : '' }`} email={this.props.email} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                        <Error testo={this.props.msgemail} />
                    </Box>
                    <Box direction='column' className='box-form-registration'>
                        <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                        <div style={{ display:'inline-flex', width: '300px' }}>
                            <TextInput id='numtel' size='medium' maxLength={15} className={`inputForm ${this.props.msgnumtel ? 'errorBoxInput' : '' }`} numtel={this.props.numtel} onChange={this.props.onChange} onBlur={this.props.onBlur} />
                            <div class="tooltipPwd"><StatusInfo className="iconTooltip" aria-label="Informazioni sul numero di telefono"/>
                                    <span class="tooltiptext">
                                    Indicare sempre il prefisso internazionale. Es: +39 per l'Italia
                                    </span>
                            </div>
                        </div>
                        <Error testo={this.props.msgnumtel} />
                    </Box>
                </Box>

            </Box>
        );
    }
}


class FormDispute extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            nome: this.props.nome,
            cognome: this.props.cognome,
            fax: this.props.fax,
            telefono: this.props.telefono,
            email: this.props.email,
            msgemail:'',
            msgnumtel:'',
            msgfax:'',
            msgnome:'',
            msgcognome:'',
            validNome: false,
            validCognome: false,
            validFax: false,
            validNumTel: false,
            validEmail: false
        }
        this.editInput = this.editInput.bind(this);
        this.validForm = this.validForm.bind(this);
    }

    editInput(e) {
        if (e.target.id === 'nome') {
            this.setState({
                nome: e.target.value
            })
        } else if (e.target.id === 'cognome') {
            this.setState({
                cognome: e.target.value
            })
        } else if (e.target.id === 'fax') {
            this.setState({
                fax: e.target.value
            })
        } else if (e.target.id === 'numtel') {
            this.setState({
                telefono: e.target.value
            })
        } else if (e.target.id === 'email') {
            this.setState({
                email: e.target.value
            })
        }
    }

    validForm(event) {
        var email = this.state.email;
        var tel = this.state.telefono;
        var fax = this.state.fax;
        var nome = this.state.nome;
        var cognome = this.state.cognome; 

        if (event.target.id === 'email') {
            if(email ===''){
                this.setState({
                    msgemail: ERRORMESSAGE.msgblank,
                    validEmail: false
                }, () => {this.checkMsg()})
            }else if (email !== '' && emailRegex.test(email) === false) { // Validazione email
                this.setState({
                    msgemail: ERRORMESSAGE.msgemail,
                    validEmail: false
                }, () => {this.checkMsg()})
            } else if (email !== '' && emailRegex.test(email)) {
                this.setState({
                    msgemail: '',
                    validEmail: true
                }, () => {this.checkMsg()})
            }
        } else if (event.target.id === 'numtel') {
            if(tel ===''){
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgblank,
                    validNumTel: false
                }, () => {this.checkMsg()})
            } else if (tel !== '' && phoneNumber.test(tel) === false) { // Validazione numero telefono
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgphonenumber,
                    validNumTel: false
                }, () => {this.checkMsg()})
            } else if (tel !== '' && tel.length < 3) { // Validazione numero telefono
                this.setState({
                    msgnumtel: ERRORMESSAGE.msglengthphonenumber,
                    validNumTel: false
                }, () => {this.checkMsg()})
            } else if (tel !== '' && phoneNumber.test(tel)) {
                this.setState({
                    msgnumtel: '',
                    validNumTel: true
                }, () => {this.checkMsg()})
            }
        } else if (event.target.id === 'fax') {
            if(fax ===''){
                this.setState({
                    msgfax: ERRORMESSAGE.msgblank,
                    validFax: false
                }, () => {this.checkMsg()})
            }else if (fax !== '' && number.test(fax) === false) { // Validazione numero telefono
                this.setState({
                    msgfax: ERRORMESSAGE.msgnumber,
                    validFax: false
                }, () => {this.checkMsg()})
            } else if (fax !== '' && fax.length < 7) { // Validazione numero telefono
                this.setState({
                    msgfax: ERRORMESSAGE.msglengthnumtel,
                    validFax: false
                }, () => {this.checkMsg()})
            } else if (fax !== '' && number.test(fax)) {
                this.setState({
                    msgfax: '',
                    validFax: true
                }, () => {this.checkMsg()})
            }
        } else if (event.target.id === 'nome') {
            if(nome ===''){
                this.setState({
                    msgnome: ERRORMESSAGE.msgblank,
                    validNome: false
                }, () => {this.checkMsg()})
            }else if (nome === '' || nome.length < 2){
                this.setState({
                    msgnome: ERRORMESSAGE.msgnomelength,
                    validNome: false
                }, () => {this.checkMsg()})  
            } else {
                this.setState({
                    msgnome: '',
                    validNome: true
                }, () => {this.checkMsg()})
            }
        }   else if (event.target.id === 'cognome') {
            if(cognome ===''){
                this.setState({
                    msgcognome: ERRORMESSAGE.msgblank,
                    validCognome: false
                }, () => {this.checkMsg()})
            }else if (cognome === '' || cognome.length < 2){
                this.setState({
                    msgcognome: ERRORMESSAGE.msgcognomelength,
                    validCognome: false
                }, () => {this.checkMsg()})  
            } else {
                this.setState({
                    msgcognome: '',
                    validCognome: true
                }, () => {this.checkMsg()})
            }
        }

    }

    checkMsg(){
        if(this.state.validCognome && this.state.validNome && this.state.validFax && this.state.validNumTel && this.state.validEmail) {
            sessionStorage.setItem('nome', this.state.nome);
            sessionStorage.setItem('cognome', this.state.cognome);
            sessionStorage.setItem('telefono', this.state.telefono);
            sessionStorage.setItem('email', this.state.email);
            sessionStorage.setItem('fax', this.state.fax);
            this.props.activeButton();
        } else {
            this.props.disableButton();
        }
    }

    render() {

        return (
            <Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>CODICE SOCIETÀ</Text>
                        <TextInput id='codsoc' aria-label='Codice Società' size='medium' className='inputFormdisp' maxLength={10} value={this.props.codsocieta}  disabled />
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>NOME</Text>
                        <TextInput id='nome' aria-label='Nome' size='medium' className={`inputFormdisp ${this.state.msgnome ? 'errorBoxInput' : '' }`} maxLength={50} value={ this.state.nome } onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgnome} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>COGNOME</Text>
                        <TextInput id='cognome' aria-label='Cognome' size='medium' className={`inputFormdisp ${this.state.msgcognome ? 'errorBoxInput' : '' }`} maxLength={50} value={ this.state.cognome } onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgcognome} />
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>FAX</Text>
                        <TextInput id='fax' aria-label='Fax' size='medium' className={`inputFormdisp ${this.state.msgfax ? 'errorBoxInput' : '' }`} maxLength={10} value={ this.state.fax } onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgfax} />
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                        <TextInput id='numtel' aria-label='Numero di telefono cellulare' size='medium' className={`inputFormdisp ${this.state.msgnumtel ? 'errorBoxInput' : '' }`} maxLength={15} value={ this.state.telefono } onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgnumtel} />
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>EMAIL</Text>
                        <TextInput id='email' aria-label='Email' size='medium' className={`inputFormdisp ${this.state.msgemail ? 'errorBoxInput' : '' }`} maxLength={50} value={ this.state.email } onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgemail} />
                    </Box>
                </Box>
            </Box>
        );
    }
}


class FormDisputeRegistered extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            nome: this.props.nome,
            cognome: this.props.cognome,
            fax: this.props.fax,
            telefono: this.props.telefono,
            email: this.props.email,
            msgemail:'',
            msgnumtel:'',
            msgfax:'',
            msgnome:'',
            msgcognome:'',
            validNome: false,
            validCognome: false,
            validFax: false,
            validNumTel: false,
            validEmail: false

        }
        this.editInput = this.editInput.bind(this);
        this.validForm = this.validForm.bind(this);
    }

    componentDidMount() {
        var email = this.state.email;
        var tel = this.state.telefono;
        var fax = this.state.fax;
        var nome = this.state.nome;
        var cognome = this.state.cognome; 
        
        if(email ===''){
            this.setState({
                msgemail: ERRORMESSAGE.msgblank,
                validEmail: false
            }, () => {this.checkMsgCallback()})
        }else if (email !== '' && emailRegex.test(email) === false) { // Validazione email
            this.setState({
                msgemail: ERRORMESSAGE.msgemail,
                validEmail: false
            }, () => {this.checkMsgCallback()})
        } else if (email !== '' && emailRegex.test(email)) {
            this.setState({
                msgemail: '',
                validEmail: true
            }, () => {this.checkMsgCallback()})
        }
        
        if(tel ===''){
            this.setState({
                msgnumtel: ERRORMESSAGE.msgblank,
                validNumTel: false
            }, () => {this.checkMsgCallback()})
        } else if (tel !== '' && phoneNumber.test(tel) === false) { // Validazione numero telefono
            this.setState({
                msgnumtel: ERRORMESSAGE.msgphonenumber,
                validNumTel: false
            }, () => {this.checkMsgCallback()})
        } else if (tel !== '' && tel.length < 3) { // Validazione numero telefono
            this.setState({
                msgnumtel: ERRORMESSAGE.msglengthphonenumber,
                validNumTel: false
            }, () => {this.checkMsgCallback()})
        } else if (tel !== '' && phoneNumber.test(tel)) {
            this.setState({
                msgnumtel: '',
                validNumTel: true
            }, () => {this.checkMsgCallback()})
        }
        
        if(fax ===''){
            this.setState({
                msgfax: ERRORMESSAGE.msgblank,
                validFax: false
            }, () => {this.checkMsgCallback()})
        } else if (fax !== '' && number.test(fax) === false) { // Validazione numero telefono
            this.setState({
                msgfax: ERRORMESSAGE.msgnumber,
                validFax: false
            }, () => {this.checkMsgCallback()})
        } else if (fax !== '' && fax.length < 7) { // Validazione numero telefono
            this.setState({
                msgfax: ERRORMESSAGE.msglengthnumtel,
                validFax: false
            }, () => {this.checkMsgCallback()})
        } else if (fax !== '' && number.test(fax)) {
            this.setState({
                msgfax: '',
                validFax: true
            }, () => {this.checkMsgCallback()})  
        }
        
        if(nome ===''){
            this.setState({
                msgnome: ERRORMESSAGE.msgblank,
                validNome: false
            }, () => {this.checkMsgCallback()})  
        }else if (nome === '' || nome.length < 2){
            this.setState({
                msgnome: ERRORMESSAGE.msgnomelength,
                validNome: false
            }, () => {this.checkMsgCallback()})  
        } else {
            this.setState({
                msgnome: '',
                validNome: true
            }, () => {this.checkMsgCallback()})
        }
        
        if(cognome ===''){
            this.setState({
                msgcognome: ERRORMESSAGE.msgblank,
                validCognome: false
            }, () => {this.checkMsgCallback()})
        }else if (cognome === '' || cognome.length < 2){
            this.setState({
                msgcognome: ERRORMESSAGE.msgcognomelength,
                validCognome: false
            }, () => {this.checkMsgCallback()}) 
        } else {
            this.setState({
                msgcognome: '',
                validCognome: true
            }, () => {this.checkMsgCallback()})
        }
    }

    checkMsgCallback(){
        if(this.state.validCognome && this.state.validNome && this.state.validFax && this.state.validNumTel && this.state.validEmail) {
            sessionStorage.setItem('nome', this.state.nome);
            sessionStorage.setItem('cognome', this.state.cognome);
            sessionStorage.setItem('telefono', this.state.telefono);
            sessionStorage.setItem('email', this.state.email);
            sessionStorage.setItem('fax', this.state.fax);
            this.props.activeButton();
        } else {
            this.props.disableButton();
        }
    }

    editInput(e) {
        if (e.target.id === 'nome') {
            this.setState({
                nome: e.target.value
            })
        } else if (e.target.id === 'cognome') {
            this.setState({
                cognome: e.target.value
            })
        } else if (e.target.id === 'fax') {
            this.setState({
                fax: e.target.value
            })
        } else if (e.target.id === 'numtel') {
            this.setState({
                telefono: e.target.value
            })
        } else if (e.target.id === 'email') {
            this.setState({
                email: e.target.value
            })
        }
    }

    validForm(event) {
        var email = this.state.email;
        var tel = this.state.telefono;
        var fax = this.state.fax;
        var nome = this.state.nome;
        var cognome = this.state.cognome; 

        if (event.target.id === 'email') {
            if(email ===''){
                this.setState({
                    msgemail: ERRORMESSAGE.msgblank,
                    validEmail: false
                }, () => {this.checkMsgCallback()})
            }else if (email !== '' && emailRegex.test(email) === false) { 
                this.setState({
                    msgemail: ERRORMESSAGE.msgemail,
                    validEmail: false
                }, () => {this.checkMsgCallback()})
            } else if (email !== '' && emailRegex.test(email)) {
                this.setState({
                    msgemail: '',
                    validEmail: true
                }, () => {this.checkMsgCallback()})
            }
        } else if (event.target.id === 'numtel') {
            if(tel ===''){
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgblank,
                    validNumTel: false
                }, () => {this.checkMsgCallback()})
            } else if (tel !== '' && phoneNumber.test(tel) === false) { 
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgphonenumber,
                    validNumTel: false
                }, () => {this.checkMsgCallback()})
            } else if (tel !== '' && tel.length < 3) { // Validazione numero telefono
                this.setState({
                    msgnumtel: ERRORMESSAGE.msglengthphonenumber,
                    validNumTel: false
                }, () => {this.checkMsgCallback()})
            } else if (tel !== '' && phoneNumber.test(tel)) {
                this.setState({
                    msgnumtel: '',
                    validNumTel: true
                }, () => {this.checkMsgCallback()})
            }
        } else if (event.target.id === 'fax') {
            if(fax ===''){
                this.setState({
                    msgfax: ERRORMESSAGE.msgblank,
                    validFax: false
                }, () => {this.checkMsgCallback()})
            } else if (fax !== '' && number.test(fax) === false) { 
                this.setState({
                    msgfax: ERRORMESSAGE.msgnumber,
                    validFax: false
                }, () => {this.checkMsgCallback()})
            } else if (fax !== '' && fax.length < 9) { // Validazione numero telefono
                this.setState({
                    msgfax: ERRORMESSAGE.msglengthnumtel,
                    validFax: false
                }, () => {this.checkMsgCallback()})
            } else if (fax !== '' && number.test(fax)) {
                this.setState({
                    msgfax: '',
                    validFax: true
                }, () => {this.checkMsgCallback()})
            }
        } else if (event.target.id === 'nome') {
            if(nome ===''){
                this.setState({
                    msgnome: ERRORMESSAGE.msgblank,
                    validNome: false
                }, () => {this.checkMsgCallback()})
            }else if (nome === '' || nome.length < 2){
                this.setState({
                    msgnome: ERRORMESSAGE.msgnomelength,
                    validNome: false
                }, () => {this.checkMsgCallback()})  
            } else {
                this.setState({
                    msgnome: '',
                    validNome: true
                }, () => {this.checkMsgCallback()})
            }
        }   else if (event.target.id === 'cognome') {
            if(cognome ===''){
                this.setState({
                    msgcognome: ERRORMESSAGE.msgblank,
                    validCognome: false
                }, () => {this.checkMsgCallback()})
            }else if (cognome === '' || cognome.length < 2){
                this.setState({
                    msgcognome: ERRORMESSAGE.msgcognomelength,
                    validCognome: false
                }, () => {this.checkMsgCallback()})  
            } else {
                this.setState({
                    msgcognome: '',
                    validCognome: true
                }, () => {this.checkMsgCallback()})
            }
        }

    }

    render() {

        return (
            <Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>CODICE SOCIETÀ</Text>
                        <TextInput id='codsoc' aria-label='Codice Società' size='medium' className={`inputFormdisp ${this.props.msgcodsoc ? 'errorBoxInput' : '' }`} maxLength={10} value={this.props.codsocieta}  disabled />
                        <Error testo={this.props.msgcodsoc}/>
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>NOME</Text>
                        <TextInput id='nome' aria-label='Nome' size='medium' className={`inputFormdisp ${this.state.msgnome ? 'errorBoxInput' : '' }`} maxLength={50} value={this.state.nome} onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgnome}/>
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>COGNOME</Text>
                        <TextInput id='cognome' aria-label='Cognome' size='medium' className={`inputFormdisp ${this.state.msgcognome ? 'errorBoxInput' : '' }`} maxLength={50} value={this.state.cognome} onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgcognome}/>
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>FAX</Text>
                        <TextInput id='fax' aria-label='Fax' size='medium' className={`inputFormdisp ${this.state.msgfax ? 'errorBoxInput' : '' }`} maxLength={10} value={this.state.fax} onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgfax}/>
                    </Box>
                </Box>
                <Box direction='row' gap='large' className='contentformdisp'>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                        <TextInput id='numtel' aria-label='Numero di telefono cellulare' size='medium' className={`inputFormdisp ${this.state.msgnumtel ? 'errorBoxInput' : '' }`} maxLength={15} value={this.state.telefono} onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgnumtel}/>
                    </Box>
                    <Box direction='column' className='box-form'>
                        <Text className='label'>EMAIL</Text>
                        <TextInput id='email' aria-label='Email' size='medium' className={`inputFormdisp ${this.state.msgemail ? 'errorBoxInput' : '' }`} maxLength={50} value={this.state.email} onChange={this.editInput} onBlur={this.validForm} />
                        <Error testo={this.state.msgemail} />
                    </Box>
                </Box>
            </Box>
        );
    }
}


class Form extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {

        }

    }

    render() {


        return (
            <Box>
                {window.location.pathname === "/SocietyRegistration" ?
                    <FormSociety nome={this.props.nome} cognome={this.props.cognome} codicefiscale={this.props.codicefiscale} email={this.props.email} showSpan={this.props.showSpan}
                        numtel={this.props.numtel} codsocieta={this.props.codsocieta} capsocieta={this.props.capsocieta} piva={this.props.piva} onChange={this.props.onChange} onBlur={this.props.onBlur}
                        msgcodsoc={this.props.msgcodsoc} msgcapsoc={this.props.msgcapsoc} msgpiva={this.props.msgpiva} msgnomleg={this.props.msgnomleg}
                        msgcodfis={this.props.msgcodfis} msgemail={this.props.msgemail} msgnumtel={this.props.msgnumtel} msgcogleg={this.props.msgcogleg} />
                    : window.location.pathname === "/ShopRegistration" ?
                        <FormShop codsocieta={this.props.codsocieta} codicepv={this.props.codicepv} capsocieta={this.props.capsocieta}
                            email={this.props.email} numtel={this.props.numtel} piva={this.props.piva} onChange={this.props.onChange} onBlur={this.props.onBlur}
                            msgcodsoc={this.props.msgcodsoc} msgcapsoc={this.props.msgcapsoc} msgpiva={this.props.msgpiva}
                            msgemail={this.props.msgemail} msgnumtel={this.props.msgnumtel} msgcodpv={this.props.msgcodpv} />
                    :   window.location.pathname === "/DisputeOnline" ?
                        <FormDispute codsocieta={this.props.codsocieta} nome={this.props.nome} cognome={this.props.cognome}
                            email={this.props.email} telefono={this.props.telefono} fax={this.props.fax} onChange={this.props.onChange}
                            msgcodsoc={this.props.msgcodsoc} msgemail={this.props.msgemail} msgnumtel={this.props.msgnumtel} msgfax={this.props.msgfax} activeButton={this.props.activeButton} disableButton={this.props.disableButton} />
                    :   <FormDisputeRegistered codsocieta={this.props.codsocieta} nome={this.props.nome} cognome={this.props.cognome}
                            email={this.props.email} telefono={this.props.telefono} fax={this.props.fax} onChange={this.props.onChange}
                            msgcodsoc={this.props.msgcodsoc} msgemail={this.props.msgemail} msgnumtel={this.props.msgnumtel} msgfax={this.props.msgfax} activeButton={this.props.activeButton} disableButton={this.props.disableButton} />}
                <Box alignItems='center'>
                    <Text className={window.location.pathname === "/SocietyRegistration" || window.location.pathname === "/ShopRegistration" ? 'string' : 'stringdis'}>{window.location.pathname === "/SocietyRegistration" || window.location.pathname === "/ShopRegistration" ? 'Tutti i campi sono obbligatori' : 'Tutti i campi sono obbligatori'}</Text>
                </Box>
            </Box>
        );
    }
}

export default Form;
